import { useContext } from "react";
import { SidebarContext } from "../../../context/SidebarContext";


export default function Overlay() {

    const { isOpen, setIsOpen, isEnabledLinks, setIsEnabledLinks, modeTouch, setModeTouch } = useContext(SidebarContext);
    const { leadsOpen, setLeadsOpen } = useContext(SidebarContext);
    const { produtosOpen, setProdutosOpen } = useContext(SidebarContext);
    const { relatoriosOpen, setRelatoriosOpen } = useContext(SidebarContext);


    function handleCloseSidebar() {
        setIsOpen(false);
        setProdutosOpen(false);
        setRelatoriosOpen(false);
        setLeadsOpen(false);
        setIsEnabledLinks(false);
        setModeTouch(false);
    }


    if (!isOpen) return null;
    return (
        <div
            className="overlay fixed inset-0 bg-black/40 backdrop-blur-[2px] z-0 transition-opacity duration-300 animate-fade-in"
            onClick={handleCloseSidebar}
        />
    );
}
